function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M2.604 16.392V2.186h11.473v11.93l2.186-1.805V1.093C16.263.489 15.774 0 15.171 0H1.51C.908 0 .42.49.42 1.093v16.391c0 .604.489 1.093 1.092 1.093h9.536l-1.545-2.185z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M19.41 11.749a.546.546 0 0 0-.723-.025l-5.012 4.143-3.34-2.004a.546.546 0 0 0-.727.784l3.62 5.122c.1.143.265.23.44.23h.006a.544.544 0 0 0 .44-.222l5.362-7.308a.547.547 0 0 0-.066-.72z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M11.62 3.825H5.061a1.093 1.093 0 0 0 0 2.185h6.557a1.092 1.092 0 0 0 0-2.185z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M11.62 7.103H5.061a1.093 1.093 0 0 0 0 2.185h6.557a1.092 1.092 0 0 0 0-2.185z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#18a1db",
  d: "M11.62 10.381H5.061a1.093 1.093 0 0 0 0 2.186h6.557a1.092 1.092 0 0 0 0-2.186z"
})))))));

var SvgIconMarkedAsComplete = function SvgIconMarkedAsComplete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMarkedAsComplete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-marked-as-complete.d3ea9e41.svg";
export { ForwardRef as ReactComponent };